import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { capitalize, Grid, Typography } from '@mui/material';
import { useDebouncedCallback } from 'use-debounce';

import { CriteriaOption } from 'commons/components/SearchRelated';
import { useUpdateQueryParams } from 'commons/components/SearchRelated/SearchWithCriteria/hooks';
import { STODocumentStatusEnum } from 'commons/enums';
import { getSTODocumentListAction } from 'redux-stores/actions';
import { RootReducerInterface } from 'redux-stores/reducers';

import { ListFilterCard, ListPage } from '../commons/components';

import STOListTable from './components/STOListTable.component';

const STOListPage: React.FC = () => {
  /** CONSTS AND FUNCTIONS */
  const { queryParams, updateQueryParams } = useUpdateQueryParams();
  const { stoDocumentList } = useSelector(
    (state: RootReducerInterface) => state.dashboard,
  );
  const statusArrayText: {
    key: STODocumentStatusEnum | 'all';
    text: string;
  }[] = [
    {
      key: 'all',
      text: 'All',
    },
    ...Object.values(STODocumentStatusEnum).map((value) => ({
      key: value,
      text: capitalize(value.replace('-', ' ')),
    })),
  ];

  const updateBinListSearchDebounce = useDebouncedCallback(
    (_searchParams, _location, _dispatch) => {
      _dispatch(
        getSTODocumentListAction({
          searchParams: _searchParams,
          locationId: _location,
        }),
      );
    },
    200,
    { maxWait: 1000 },
  );

  /** STATE AND HOOKS */
  const [statusFilter, setStatusFilter] =
    useState<STODocumentStatusEnum | null>(null);

  const handleStatusFilter = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    value: STODocumentStatusEnum,
  ): void => {
    setStatusFilter(value);
    updateQueryParams(
      { status: value },
      { clearQueryParams: ['page', 'is_assigned'] },
    );
  };

  const searchCriteria: CriteriaOption[] = [
    {
      name: 'STO Numbers',
      id: 'sto_numbers',
      isArray: true,
      parameterMapping: 'sto_numbers',
    },
  ];
  return (
    <ListPage updateListSearchDebounce={updateBinListSearchDebounce}>
      <ListFilterCard
        statusArrayText={statusArrayText}
        searchCriteria={searchCriteria}
        statusFilter={statusFilter}
        handleStatusFilter={handleStatusFilter}
      />
      {Object.keys(queryParams).includes('status') ? (
        <STOListTable data={stoDocumentList} />
      ) : (
        <Grid container justifyContent="center">
          <Typography>Please select a status</Typography>
        </Grid>
      )}
    </ListPage>
  );
};

export default STOListPage;
